<script>
    import {fade} from 'svelte/transition'
</script>


<div class="col s12 m8 l9" in:fade={{duration: 500}}>
    <div class="container main-container">

        <slot></slot>

    </div>
</div>
